import { InvoiceHoursSourceTypeDTO } from '../types/dto/invoice-hours-source-type.dto';
import { InvoiceHoursSourceResponse } from '../types/dto/response';
import { InvoiceHoursSource, InvoiceHoursSourceType } from '../types/generate-invoices';

/**
 * Maps invoice hours source type from DTO to domain enum
 */
export const mapInvoiceHoursSourceTypeFromDTO = (
  dto: InvoiceHoursSourceTypeDTO
): InvoiceHoursSourceType => {
  switch (dto) {
    case InvoiceHoursSourceTypeDTO.TRACKED_BILLABLE:
      return InvoiceHoursSourceType.TRACKED_BILLABLE;
    case InvoiceHoursSourceTypeDTO.TRACKED_TOTAL:
      return InvoiceHoursSourceType.TRACKED_TOTAL;
    case InvoiceHoursSourceTypeDTO.BOOKED_BILLABLE:
      return InvoiceHoursSourceType.BOOKED_BILLABLE;
    case InvoiceHoursSourceTypeDTO.BOOKED_TOTAL:
      return InvoiceHoursSourceType.BOOKED_TOTAL;
    case InvoiceHoursSourceTypeDTO.CAPACITY:
      return InvoiceHoursSourceType.CAPACITY;
    case InvoiceHoursSourceTypeDTO.APPROVED_BILLABLE:
      return InvoiceHoursSourceType.APPROVED_BILLABLE;
    case InvoiceHoursSourceTypeDTO.APPROVED_TOTAL:
      return InvoiceHoursSourceType.APPROVED_TOTAL;
    case InvoiceHoursSourceTypeDTO.TIME_OFF:
      return InvoiceHoursSourceType.TIME_OFF;
    default:
      return InvoiceHoursSourceType.TRACKED_BILLABLE;
  }
};

/**
 * Maps invoice hours source from DTO response to domain model
 */
export const mapInvoiceHoursSourceFromDTO = (
  dto: InvoiceHoursSourceResponse
): InvoiceHoursSource => {
  return {
    sourceType: mapInvoiceHoursSourceTypeFromDTO(dto.sourceType),
    hours: parseFloat(dto.hours),
    amount: parseFloat(dto.amount),
    currencyCode: dto.currencyCode,
    averageRate: parseFloat(dto.averageRate),
  };
};

/**
 * Maps array of invoice hours sources from DTO to domain models
 */
export const mapInvoiceHoursSourcesFromDTO = (
  dtos: InvoiceHoursSourceResponse[]
): InvoiceHoursSource[] => {
  return dtos.map(mapInvoiceHoursSourceFromDTO);
};
